
import { findFaqs, buildFaqPageSchema } from '@/utils/faqSchema'

export default {
  props: {
    header: {
      default: 'Frequently Asked <strong>Questions</strong>',
      type: String,
    },
    dark: {
      default: 'true',
      type: String,
    },
  },
  // Built from the slot vnodes rather than the rendered DOM, so the schema is in the
  // statically generated HTML and visible to crawlers that don't run JavaScript
  head() {
    const schema = buildFaqPageSchema(findFaqs(this.$slots.default))
    if (!schema) return {}
    return {
      script: [{ type: 'application/ld+json', json: schema }]
    }
  },
}
